module.exports = __webpack_public_path__ + "static/media/Bering_Sea.894cf620.mp3";